import { FormListOperation, Button, Form } from 'antd';
import React from 'react';

export type AddCustomRequestButtonProps = FormListOperation['add'];

const AddCustomRequestButtonImpl = ({ add }: { add: FormListOperation['add'] }): JSX.Element => {
    const addNewCustomRequest = (): void => {
        add();
    };

    return (
        <>
            <Form.Item>
                <Button htmlType='button' size={'small'} onClick={() => addNewCustomRequest()}>
                    Add Custom Request
                </Button>
            </Form.Item>
        </>
    );
};

export const AddCustomRequestButton = React.memo(AddCustomRequestButtonImpl);
